import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Col} from 'react-bootstrap'; 
import { useFormatDate } from 'hooks'; 

const EmailList = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]); 
  const [list, setList] = React.useState(true); 

  const columns = [ 
    {
      accessor: 'title',
      Header: 'Titre',
      headerProps: { className: 'text-900' }
    }, 
    {
      accessor: 'list',
      Header: 'Liste',
      headerProps: { className: 'text-900' },
      Cell: ({row}) => { 
        return <div>
            {row.original?.list?.map((l)=>{
                return <><a class="badge badge rounded-pill badge-subtle-primary">{l.label}</a><br/></>
            })}
        </div>
      }
    }, 
    {
      accessor: 'total',
      Header: 'Total',
      headerProps: { className: 'text-900' },
      Cell: ({row}) => { 
        return (<p>{row.original?.senders?.length}/{row.original.total?.length ? row.original.total?.length : row.original?.senders?.length}</p>)
      }
    }, 
    {
      accessor: 'message',
      Header: 'Message',
      headerProps: { className: 'text-900' }, 
      Cell: ({row}) => { 
        return (<div
            dangerouslySetInnerHTML={{
              __html: row.original.message
            }}/>)
      }
    }, 
    {
      accessor: '_create_At',
      Header: 'Date',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
        <>{row?.original?._create_At && row?.original?._create_At?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
               {useFormatDate(row.original?._create_At?.toDate(), {
                   day:'numeric',
                 weekday: 'short',
                 year: 'numeric',
                 month: 'short', 
               })}
             </small> 
         )}
         </>
      )
    },  
  ];

  const loadUsers = () => {
    firebase.firestore().collection('mailings').get().then((snap)=> {
      let s = [];
       
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        // console.log(l?.delete)
        if (l?.delete != true){
          s.push(l)
        } 
        
      })
      setData(s);  
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  React.useEffect(() => {
    if (data.length === 0){
      loadUsers()
    }
  }, []);
 

function AdvanceTableExample( ) {

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      <IconButton  href="/email/new"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouvel email</span>
      </IconButton> 
 
 
      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <>
      {l ? <p>Chargement... </p>: (<FalconComponentCard>
        
        <FalconComponentCard.Header
          title={ "Liste des emails envoyé"  }
          light={false}
         
          className="border-bottom border-200" noPreview={true} 
        />
        <FalconComponentCard.Body>
          <AdvanceTableExample arch={!list}/>
        </FalconComponentCard.Body>
  
          
      </FalconComponentCard>)}</>
    );
}

export default EmailList;
